import { useEffect } from "react"

export const useEffectAsync = (effect: () => Promise<void>, deps: any[]) => {
    useEffect(() => {
        effect()
    }, deps)
}